import { useEffect, useCallback } from 'react';

import symbol from 'assets/games/theme-two/slot/symbol.png';

import styles from './stars.module.css';

export default function Stars() {
  const getRandomInt = useCallback((min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }, []);

  useEffect(() => {
    const container = document.getElementById('stars-container');
    function createAndAnimateImage() {
      // Создаем элемент изображения
      const img = document.createElement('img');
      img.src = symbol;

      const x = container.offsetWidth / 2;
      const y = container.offsetHeight / 2;

      img.style.position = 'absolute';
      img.style.opacity = '0.6';
      img.style.left = `${x}px`;
      img.style.top = `${y}px`;
      const size = getRandomInt(20, 50);
      img.style.width = `${size}px`;
      img.style.height = `${size}px`;
      img.style.backdropFilter = `blur(${getRandomInt(0, 4)}px)`;
      const angle = getRandomInt(0, 50);
      img.style.angle = `-${angle}deg`;

      container.appendChild(img);

      const dx = Math.random() * 10 - 5;
      const dy = Math.random() * 10 - 5;

      function moveImage() {
        let currentX = parseFloat(img.style.left);
        let currentY = parseFloat(img.style.top);

        currentX += dx;
        currentY += dy;

        img.style.left = `${currentX}px`;
        img.style.top = `${currentY}px`;

        if (
          currentX < -img.width ||
          currentX > container.offsetWidth ||
          currentY < -img.height ||
          currentY > container.offsetHeight
        ) {
          container.removeChild(img);
          createAndAnimateImage();
        } else {
          requestAnimationFrame(moveImage);
        }
      }

      requestAnimationFrame(moveImage);
    }

    // BG SYMBOLS ANIMATION COUNT
    for (let i = 0; i < 30; i++) {
      createAndAnimateImage();
    }
  }, [getRandomInt]);

  return <div id="stars-container" className={styles.StarsContainer}></div>;
}
